import { Command } from '@ckeditor/ckeditor5-core';
import config from "@/components/ckeditor/config";
import { View } from '@ckeditor/ckeditor5-ui';

export default class VueLinkCommand extends Command {
    execute({ packet }) {
        this.editor.model.change(writer => {

            if (packet.tab == "internal") {
                const router = config.vueContext.config.globalProperties.$router;
                const routeData = router.resolve({ name: packet.v });

                const viewFragment = this.editor.data.processor.toView(`<a href="${routeData.href}" target="${packet.newTab ? "_blank" : "_self"}">${packet.text || routeData.name}</a>&nbsp;`);
                const modelFragment = this.editor.data.toModel(viewFragment);
                const insertPosition = this.editor.model.document.selection.getFirstPosition();
                this.editor.model.insertContent(modelFragment, insertPosition);
            }
            else if (packet.tab == "external") {
                const viewFragment = this.editor.data.processor.toView(`<a href="${packet.v}" target="${packet.newTab ? "_blank" : "_self"}">${packet.text || packet.v}</a>&nbsp;`);
                const modelFragment = this.editor.data.toModel(viewFragment);
                const insertPosition = this.editor.model.document.selection.getFirstPosition();
                this.editor.model.insertContent(modelFragment, insertPosition);
            }
            else if (packet.tab == "file") {
                const viewFragment = this.editor.data.processor.toView(`<a href="${packet.v.uri}" target="_blank" download="${packet.v.name}">${packet.text || packet.v.name}</a>&nbsp;`);
                const modelFragment = this.editor.data.toModel(viewFragment);
                const insertPosition = this.editor.model.document.selection.getFirstPosition();
                this.editor.model.insertContent(modelFragment, insertPosition);
            }
            else if (packet.tab == "email") {
                const viewFragment = this.editor.data.processor.toView(`<a href="${packet.v}" target="${packet.newTab ? "_blank" : "_self"}">${packet.text || packet.v}</a>&nbsp;`);
                const modelFragment = this.editor.data.toModel(viewFragment);
                const insertPosition = this.editor.model.document.selection.getFirstPosition();
                this.editor.model.insertContent(modelFragment, insertPosition);
            }
            else {
                console.error("Invalid tab.", packet);
            }

        });
    }

    refresh() {
        const model = this.editor.model;
        const selection = model.document.selection;
        const allowedIn = true;//model.schema.findAllowedParent(selection.getFirstPosition(), 'routerLink');

        this.isEnabled = allowedIn !== null;
    }
}
